"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyAttribute = exports.setAttributePercent = void 0;
const Record_1 = require("../../utils/Record");
const Math_1 = require("../../utils/Math");
const AttributeType_1 = require("../enums/AttributeType");
const core_1 = require("../events/core");
function setAttributePercent(level, attributes, attribute, lastPrimaryValue, nextPrimaryValue) {
    const last = (0, Math_1.calculateLevelScaledLog)(level, lastPrimaryValue);
    const next = (0, Math_1.calculateLevelScaledLog)(level, nextPrimaryValue);
    // diff
    // next === last = 0
    // next > last = positive
    // last < next = negative
    const diff = next - last;
    const currentTotal = (0, Record_1.getValueOrDefaultTo)(attributes, attribute, 0);
    (0, Record_1.setValue)(attributes, attribute, currentTotal + diff);
    return [
        new core_1.AttributeChangedEventArgs(attribute, currentTotal + diff)
    ];
}
exports.setAttributePercent = setAttributePercent;
function applyAttribute(level, attributes, attribute, diff) {
    const last = (0, Record_1.getValueOrDefaultTo)(attributes, attribute, 0);
    const next = (0, Record_1.setValue)(attributes, attribute, last + diff);
    switch (attribute) {
        case AttributeType_1.AttributeType.Vitality: {
            const baseHp = (0, Record_1.getValueOrDefaultTo)(attributes, AttributeType_1.AttributeType.Health, 0);
            (0, Record_1.setValue)(attributes, AttributeType_1.AttributeType.Health, baseHp + diff * 5);
            const baseHealPercent = (0, Record_1.getValueOrDefaultTo)(attributes, AttributeType_1.AttributeType.PercentHealingIncrease, 0);
            (0, Record_1.setValue)(attributes, AttributeType_1.AttributeType.PercentHealingIncrease, baseHealPercent + diff * .1);
            break;
        }
        case AttributeType_1.AttributeType.Luck: {
            setAttributePercent(level, attributes, AttributeType_1.AttributeType.CriticalStrikeChance, last, next);
            break;
        }
    }
}
exports.applyAttribute = applyAttribute;
